var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLab = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Lab"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M20.4002 17.9982L14.4199 7.19035V2.81287H15.0251C15.3578 2.81287 15.6304 2.51762 15.6304 2.15643C15.6304 1.79525 15.3581 1.5 15.0251 1.5H8.97478C8.64216 1.5 8.36955 1.79525 8.36955 2.15643C8.36955 2.51762 8.64177 2.81287 8.97478 2.81287H9.58001V7.19035L3.59974 17.9982C2.23013 20.474 3.28764 22.5 5.9498 22.5H18.0505C20.7127 22.5 21.7698 20.4744 20.4002 17.9982ZM6.87642 14.6253L10.7897 7.55154V2.81329H13.2098V7.55154L17.1231 14.6253H6.87642Z",
  fill: "currentColor"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/lab.757e6e99c5a1ec9e27b79d8253cc3a15.svg";